import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEnglish from '@/src/i18n/en/translation.json';
import translationSpanish from '@/src/i18n/es/translation.json';

export const resources = {
    en: {
        translation: translationEnglish,
    },
    es: {
        translation: translationSpanish,
    },
} as const;

i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    interpolation: {
        escapeValue: false,
    },
    fallbackLng: [ 'en' ],
});

export default i18n;
